import { Grid2 } from "@mui/material";
import React, { useState } from "react";
import Product from "../../components/product/Product";
import ModalPayment from "../../components/modal/ModalPayment";

const data = [
  {
    name: "Game",
    image: "/images/image/product-1.png",
    price: 150,
  },
  {
    name: "Desktop",
    image: "/images/image/product-2.png",
    price: 5000,
  },
  {
    name: "Drone",
    image: "/images/image/product-3.png",
    price: 3000,
  },
  {
    name: "Camera",
    image: "/images/image/product-4.png",
    price: 3000,
  },
  {
    name: "Phone",
    image: "/images/image/product-5.png",
    price: 2000,
  },
  {
    name: "Earphone",
    image: "/images/image/product-6.png",
    price: 1000,
  },
];

export default function Home() {
  const [open, setOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});
  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    setOpen(true);
  };
  const handleBuyNow = (data) => {
    setCurrentProduct(data);
    handleOpenModal();
  };

  return (
    <Grid2
      container
      spacing={8}
      marginTop={5}
      sx={{
        justifyContent: "space-between",
        paddingTop: { xs: 5, sm: 5, md: 5 },
      }}
      rowSpacing={8}
    >
      {data.map((product, index) => {
        return (
          <Grid2
            key={index}
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{
              borderRadius: "8px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Product {...product} handleBuyNow={() => handleBuyNow(product)} />
          </Grid2>
        );
      })}
      <ModalPayment
        resetData={() => {
          setCurrentProduct({});
        }}
        open={open}
        handleClose={handleCloseModal}
        data={currentProduct}
      />
    </Grid2>
  );
}
